<template>
  <div>
    <div class="card mb-2" style="height: inherit !important">
      <div class="card-header">
        <ChatSelectGroup
          :show-model="false"
          :show-personality="false"
          :show-rag="false"
          v-model:model="selectedModel"
          v-model:model-label="selectedModelLabel"
        />
      </div>
      <div class="col-lg-12 mt-1 mt-lg-0 px-4">
        <div :id="[`accordionRental1`]" class="accordion">
          <div class="accordion-item">
            <div :id="[`heading-1`]" class="accordion-header">
              <button
                class="accordion-button border-bottom font-weight-bold collapsed text-xs px-0 pt-0"
                type="button"
                @click="toggleAccordion()"
                data-bs-toggle="collapse"
                :data-bs-target="[`#collapse-1`]"
                :aria-expanded="isOpen ? 'true' : 'false'"
                :aria-controls="[`collapse-1`]"
              >
                <span class="text-xs">添付ファイルの詳細</span>
                <i
                  class="collapse-close fa fa-plus text-xs pt-1 position-absolute end-0 me-3"
                  aria-hidden="true"
                  ><span class="ps-1">開く</span></i
                >
                <i
                  class="collapse-open fa fa-minus text-xs pt-1 position-absolute end-0 me-3"
                  aria-hidden="true"
                  ><span class="ps-1">閉じる</span></i
                >
              </button>
            </div>

            <div
              :id="[`collapse-1`]"
              class="accordion-collapse collapse"
              :class="{ show: isOpen }"
              :aria-labelledby="[`heading-1`]"
              :data-bs-parent="[`#accordionRental-1`]"
              style=""
            >
              <div class="accordion-body text-sm px-0">
                <textarea
                  class="form-control flex-grow-1 mb-3 bg-light text-xs"
                  rows="6"
                  placeholder="文字起こしの内容がここに表示されます"
                  readonly
                  v-html="transcriptionResult"
                ></textarea>
                <div class="d-flex align-items-stretch gap-3">
                  <div class="d-flex gap-3">
                    <button
                      class="btn btn-secondary btn-md px-4 py-2 text-xxs"
                      @click.prevent="$emit('click-cleansing', true)"
                    >
                      文字起こしの<br />クレンジング
                    </button>
                    <button
                      v-if="!this.$store.state.isMobileOpen"
                      class="btn btn-secondary btn-md px-4 py-2 text-xxs"
                      @click.prevent="$emit('click-summary', true)"
                    >
                      文章を要約
                    </button>
                    <button
                      class="btn btn-secondary btn-md px-4 py-2 text-xxs"
                      @click.prevent="$emit('click-minutes', true)"
                    >
                      議事録を作成
                    </button>
                  </div>

                  <button
                    class="btn btn-sm btn-outline-secondary px-2 mb-0 d-flex ms-auto gap-1"
                    type="button"
                    style="height: 2rem"
                    @click="copyToClipboard(transcriptionResult)"
                  >
                    <i class="fas fa-copy" style="font-size: 0.75rem"></i>
                    コピーする
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="messages.length > 0"
      class="card"
      :style="{ height: cardHeight }"
    >
      <div class="card-body message-body-wrapper pb-0" ref="messageBody">
        <!-- 交互表示 -->
        <div v-for="(message, index) in messages" :key="index" class="mb-4">
          <!-- ユーザーのメッセージ（右）-->
          <div
            v-if="message.is_user"
            class="d-flex justify-content-end pe-3 mb-3"
          >
            <div class="message-wrapper">
              <div class="user-message-bubble">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <p
                  class="mb-0 text-sm text-dark"
                  v-html="parseMarkdown(message.text)"
                ></p>
              </div>
            </div>
          </div>

          <!-- AIのメッセージ（左）-->
          <div
            v-else
            class="d-flex justify-content-start mb-3"
            :class="{ 'message-preparing-answer': message.is_preparing }"
          >
            <div class="input-wrapper">
              <div class="bg-white border rounded p-3 shadow-sm">
                <div v-if="!message.text" class="d-flex align-items-center">
                  <div class="spinner-grow text-dark me-2" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <span v-if="this.$store.state.isMobileOpen">
                    ただいま回答準備中です。
                  </span>
                  <span v-else>
                    ただいま回答準備中です。少々お待ちください。
                  </span>
                </div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div
                  class="mb-2 text-dark"
                  v-html="parseMarkdown(message.text)"
                ></div>
                <div
                  v-if="message.text"
                  class="d-flex justify-content-end gap-2"
                >
                  <div class="input-group input-group-sm" style="width: auto">
                    <!-- 左：ファイルタイプ選択 -->
                    <select
                      v-model="selectedTypes[message.id]"
                      class="form-select text-secondary"
                      style="max-width: 100px"
                    >
                      <option value="">形式</option>
                      <option value="pptx">pptx</option>
                      <option value="xlsx">Excel</option>
                      <option value="docx">Word</option>
                    </select>

                    <!-- 右：ダウンロードボタン -->
                    <button
                      class="btn btn-outline-secondary gap-1 mb-0"
                      type="button"
                      @click="handleOfficeFileDownload(message.id)"
                    >
                      <i class="fas fa-download"></i>
                      ダウンロード
                    </button>
                  </div>
                  <button
                    v-if="message.text"
                    class="btn btn-sm btn-outline-secondary px-2 mb-0"
                    type="button"
                    @click="copyToClipboard(message.text)"
                  >
                    <i class="fas fa-copy" style="font-size: 0.75rem"></i>
                    コピーする
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 入力欄 -->
      <div
        class="position-sticky bottom-0 p-3 pt-2 mt-5 px-md-5 d-flex justify-content-center"
      >
        <div class="w-100 d-flex justify-content-center">
          <div
            class="input-group shadow-sm input-text-wrapper input-textarea input-wrapper-layout align-items-end"
          >
            <!-- 選択モデル -->
            <div
              v-if="selectedModel"
              @click.stop="toggleToolMenu"
              class="selected-model-container"
            >
              <label class="selected-model-chip">
                言語モデル：{{ selectedModelLabel }}
              </label>
            </div>

            <!-- モデル選択メニュー -->
            <div v-if="showToolMenu" class="tool-menu">
              <div class="tool-menu-title">言語モデル</div>

              <div
                v-for="model in selectedModelOptions"
                :key="model.value"
                class="tool-menu-item"
                @click="selectModel(model)"
              >
                {{ model.label }}
              </div>
            </div>

            <div class="input-left-tools">
              <!-- +ボタン -->
              <label
                v-if="false"
                class="btn-plus mb-0"
                @click.stop="toggleToolMenu"
              >
                <i class="fas fa-plus" style="font-size: 18px; color: #555"></i>
              </label>
            </div>

            <textarea
              :class="[
                'form-control',
                { 'border-0': true, 'shadow-none': true, expanded: focused },
              ]"
              placeholder="気軽に質問してね！"
              @focus="focused = true"
              @blur="focused = false"
              v-model="userInput"
              @keydown.enter.exact.prevent="submitMessage"
              @keydown.enter.ctrl="insertNewLine"
              maxlength="7000"
            ></textarea>
            <!-- 送信ボタン/停止ボタン -->
            <div
              class="btn btn-icon-only btn-icon-send text-white rounded-circle"
              :class="isStreaming ? 'bg-secondary' : 'bg-dark'"
              @click="handleSubmitOrStop"
            >
              <i v-if="!isStreaming" class="far fa-comment-dots"></i>
              <i v-else class="fas fa-stop"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'
import ChatSelectGroup from '@/components/PageLayout/App/ChatSelectGroup.vue'

export default {
  name: 'ChatCard',
  components: {
    ChatSelectGroup,
  },
  props: {
    transcriptionResult: {
      type: String,
      required: true,
    },
    messages: {
      type: Array,
      required: true,
    },
    parseMarkdown: {
      type: Function,
      required: true,
    },
    model: {
      type: String,
      default: '',
    },
    modelLabel: {
      type: String,
      default: '',
    },
    modelOptions: {
      type: Array,
      required: true,
    },
    isHistoryLoaded: {
      type: Boolean,
      default: false,
    },
    isStreaming: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'click-cleansing',
    'click-summary',
    'click-minutes',
    'handle-office-file-download',
    'handle-selected-model',
    'handle-selected-model-label',
    'send-message',
    'stop-stream',
  ],
  data() {
    return {
      // 初期値（ヘッダー等の高さに合わせる）
      cardHeight: 'calc(100vh - 200px)',
      focused: false,
      newMessage: '',
      userInput: '',
      selectedModel: this.model,
      selectedModelLabel: this.modelLabel,
      selectedModelOptions: this.modelOptions,
      isOpen: true,
      selectedTypes: {},
      showToolMenu: false,
    }
  },
  methods: {
    handleOfficeFileDownload(messageId) {
      const type = this.selectedTypes[messageId]

      if (!type) {
        alert('形式を選択してください')
        return
      }

      this.$emit('handle-office-file-download', messageId, type)
    },
    handleSubmitOrStop() {
      if (this.isStreaming) {
        this.$emit('stop-stream')
      } else {
        this.submitMessage()
      }
    },
    toggleToolMenu() {
      this.showToolMenu = !this.showToolMenu
    },
    selectModel(model) {
      this.showToolMenu = false
      this.selectedModel = model.value
      this.selectedModelLabel = model.label
      this.$emit('handle-selected-model', model.value)
      this.$emit('handle-selected-model-label', model.label)
    },
    toggleAccordion() {
      this.isOpen = !this.isOpen
    },
    sanitize(html) {
      return DOMPurify.sanitize(html)
    },
    submitMessage() {
      const trimmed = this.userInput.trim()
      if (trimmed) {
        this.$emit('send-message', trimmed)
        this.userInput = ''
      }
    },
    insertNewLine(event) {
      const textarea = event.target
      const start = textarea.selectionStart
      const end = textarea.selectionEnd
      this.userInput =
        this.userInput.substring(0, start) +
        '\n' +
        this.userInput.substring(end)
      this.$nextTick(() => {
        textarea.selectionStart = textarea.selectionEnd = start + 1
      })
    },
    copyToClipboard(text) {
      const processedText = text.replace(/\\n/g, '\n')
      navigator.clipboard.writeText(processedText)
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageBody
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
  },
  watch: {
    messages: {
      handler(newMessages) {
        if (this.isPreparingAnswer) {
          this.scrollToBottom()
        }
        if (this.isHistoryLoaded) {
          this.scrollToBottom()
        }
        newMessages.forEach((m) => {
          if (!(m.id in this.selectedTypes)) {
            this.selectedTypes[m.id] = ''
          }
        })
      },
      deep: true,
      immediate: true,
    },
    selectedModel(newVal) {
      this.$emit('handle-selected-model', newVal)
    },
    selectedModelLabel(newVal) {
      this.$emit('handle-selected-model-label', newVal)
    },
  },
  computed: {
    isPreparingAnswer() {
      return this.messages.some((m) => !m.is_user && !m.text)
    },
  },
  mounted() {
    this.scrollToBottom()
  },
}
</script>
